import dayjs from 'dayjs';
import { useEffect } from 'react';

import { AdnginInContent } from '../components/AdnginInContent';
import { PrankRevealModal } from '../components/PrankRevealModal';
import RoundsNavigation from '../components/RoundsNavigation';
import { useDailySeed } from '../hooks/useDailySeed';
import {
  TodaysCountryProvider,
  useTodaysCountry,
} from '../providers/TodaysCountryProvider';
import { useUser } from '../providers/UserProvider';
import Round from './rounds/Round';

const PrankModalContainer = () => {
  const {
    showPrankModal,
    setShowPrankModal,
    dismissPrank,
    isPrankMode,
    isPrankRevealed,
    isArchive,
  } = useTodaysCountry();
  const baseDayString = useDailySeed(isArchive);
  const prankSeed = isPrankMode ? `prank-${baseDayString}` : undefined;

  useEffect(() => {
    if (!isPrankRevealed) return;
    const handler = () => setShowPrankModal(true);
    window.addEventListener('open-prank-modal', handler);
    return () => window.removeEventListener('open-prank-modal', handler);
  }, [isPrankRevealed, setShowPrankModal]);

  return (
    <PrankRevealModal
      open={showPrankModal}
      onClose={() => setShowPrankModal(false)}
      onPlayRealGame={() => {
        setShowPrankModal(false);
        dismissPrank();
      }}
      prankSeed={prankSeed}
    />
  );
};

const GameRoute = () => {
  const { userDetails } = useUser();
  const today = dayjs().format('YYYY-MM-DD');

  return (
    <TodaysCountryProvider dayString={today} isArchive={false}>
      <RoundsNavigation />
      <Round />
      {!userDetails?.premiumGames?.includes('flagle') && <AdnginInContent />}
      <PrankModalContainer />
    </TodaysCountryProvider>
  );
};

export default GameRoute;
